import { BaseConfig } from '../ServiceConfig';

export interface TrackerMonitorConfig {
  isEnable: boolean;
  provider: string;
  config: string;
}

export interface TrackerConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.TrackerServiceConfigData';
  url: string;
  clientId: string;
  eventDbSize: number;
  eventUploadBatchSize: number;
  eventUploadDelayMs: number;
  eventUploadThreshold: number;
  enableNetworkRequestEvent: boolean;
  monitorConfig: TrackerMonitorConfig;
}

export const TrackerConfigurationFields: (keyof TrackerConfiguration)[] = [
  'url',
  'clientId',
  'eventDbSize',
  'eventUploadBatchSize',
  'eventUploadDelayMs',
  'eventUploadThreshold',
  'enableNetworkRequestEvent',
  'monitorConfig',
];

export const BlankTrackerConfiguration: TrackerConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.TrackerServiceConfigData',
} as TrackerConfiguration;
